
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Settings, BookOpen, Database, LogOut } from 'lucide-react';

interface SuperAdminHeaderProps {
  title: string;
  description: string;
  onNavigateToSettings?: () => void;
  userRole?: string;
  onLogout?: () => void;
}

const SuperAdminHeader: React.FC<SuperAdminHeaderProps> = ({ 
  title, 
  description, 
  onNavigateToSettings,
  userRole,
  onLogout
}) => {
  const navigate = useNavigate();
  
  const handleKnowledgeBaseClick = () => {
    navigate('/super-admin/knowledge-base');
  };
  
  const handleReferralBankClick = () => {
    navigate('/super-admin/referral-bank');
  };
  
  return (
    <div className="border-t-4 border-primary-blue pt-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
        <div>
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {userRole && (
              <span className="ml-3 px-3 py-1 text-xs font-semibold text-white rounded-full bg-purple-600">
                {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
              </span>
            )}
          </div>
          <p className="text-gray-600">{description}</p>
        </div>
        <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-2">
          <Button 
            variant="outline" 
            className="flex items-center"
            onClick={handleKnowledgeBaseClick}
          >
            <BookOpen className="mr-2 h-4 w-4" />
            Knowledge Base
          </Button>

          <Button 
            variant="outline" 
            className="flex items-center"
            onClick={handleReferralBankClick}
          >
            <Database className="mr-2 h-4 w-4" />
            Referral ID Bank
          </Button>
          
          {onNavigateToSettings && (
            <Button 
              variant="outline" 
              className="flex items-center"
              onClick={onNavigateToSettings}
            >
              <Settings className="mr-2 h-4 w-4" />
              System Settings
            </Button>
          )}
          
          {onLogout && (
            <Button 
              variant="destructive" 
              className="flex items-center"
              onClick={onLogout}
            >
              <LogOut className="mr-2 h-4 w-4" />
              Logout
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminHeader;
